<template>
  <v-menu
    v-model="menuPicker"
    :close-on-content-click="false"
    transition="scale-transition"
    min-width="290px"
    nudge-top="-6"
    offset-y
    offset-overflow
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-mask="'####-##-##'"
        v-bind="$attrs"
        :value="data"
        append-icon="mdi-calendar"
        hint="YYYY-MM-DD"
        :error="invalidDate"
        :error-messages="invalidDateMessage"
        v-on="{ ...$listeners, ...on }"
        @blur="onBlur"
      />
    </template>

    <v-date-picker
      v-model="pickerDate"
      v-bind="$attrs"
      :locale="$i18n.locale"
      scrollable
      show-week
      v-on="$listeners"
      @input="menuPicker = false"
    />
  </v-menu>
</template>

<script>
import ModelMixin from '../../mixins/model';

export default {
  mixins: [
    ModelMixin,
  ],

  props: {
    value: { type: String, default: '' },
  },

  data() {
    return {
      menuPicker: false,
      pickerDate: '',
      invalidDate: false,
      invalidDateMessage: undefined,
    };
  },

  watch: {
    data(newValue) {
      if (_.isEmpty(newValue)) {
        return;
      }

      const d = moment(newValue, 'YYYY-MM-DD', true);
      if (d.isValid()) {
        this.pickerDate = d.format('YYYY-MM-DD');
      }
    },

    pickerDate(newValue) {
      this.data = newValue;
    },
  },

  mounted() {
    this.pickerDate = this.data;
  },

  methods: {
    validate(s) {
      if (_.isEmpty(s)) {
        return;
      }
      const d = moment(s, 'YYYY-MM-DD', true);
      this.invalidDate = !d.isValid();
      this.invalidDateMessage = this.invalidDate ? this.$t('common.error.date') : undefined;
    },

    onBlur(event) {
      let t = event.relatedTarget;
      while (t) {
        if (t.classList && t.classList.contains('v-picker--date')) {
          break;
        }
        t = t.parentNode;
      }
      if (!t) {
        this.menuPicker = false;
      }
      this.validate(this.data);
    },
  }
};
</script>
